import each from 'lodash-es/each';
import mapStyles from '../../config/mapStyles';
import LocationsInRange from './LocationsInRange.jsx';

const locationsUrl = `https://cdn.shopify.com/s/files/1/0070/8853/7651/t/8/assets/stores.json?${new Date().getTime()}`;

let map = null;
let locationsJSON = null;
let geocoder = null;
let infoWindow = null;

const markers = {};

const getLocations = () => {
  if (locationsJSON) {
    return Promise.resolve(locationsJSON);
  }

  return fetch(locationsUrl)
    .then((response) => response.json())
    .then((data) => {
      locationsJSON = data; // Parsing response as JSON
      return locationsJSON;
    });
};

const getLocationsInRange = async (origin, range) => {
  const locations = await getLocations();

  const locationsInRange = locations.features
    .filter((item) => {
      const lat = Number(item.geometry.coordinates[0]);
      const lng = Number(item.geometry.coordinates[1]);

      const validLat = lat <= 180 && lat >= -180;
      const validLng = lng <= 180 && lng >= -180;

      return validLat && validLng;
    })
    .map((item) => {
      const lat = Number(item.geometry.coordinates[0]);
      const lng = Number(item.geometry.coordinates[1]);

      const locationLatLng = new window.google.maps.LatLng(lat, lng);

      const distance = window.google.maps.geometry.spherical.computeDistanceBetween(origin, locationLatLng);

      const miles = distance * 0.000621371192;

      const itemWithDistance = { ...item };
      itemWithDistance.properties.distance = miles;

      return itemWithDistance;
    })
    .filter((item) => {
      return item.properties.distance < range;
    });

  return locationsInRange;
};

const setBoundsToLocations = (locations) => {
  if (locations.length === 0) {
    return;
  }

  const bounds = new window.google.maps.LatLngBounds();

  each(locations, (item) => {
    const locationLatLng = new window.google.maps.LatLng(item.geometry.coordinates[0], item.geometry.coordinates[1]);
    bounds.extend(locationLatLng);
  });

  map.fitBounds(bounds);
};

const initStoreLocator = async () => {
  const mapElement = document.querySelector('[data-store-locator-map]'); // Changed variable name

  geocoder = new window.google.maps.Geocoder();
  infoWindow = new window.google.maps.InfoWindow();

  document.querySelector('[data-store-locator-results]').classList.remove('StoreLocator__results--loading');

  map = new window.google.maps.Map(mapElement, {
    styles: mapStyles,
    zoom: 4,
    center: { lat: 39.8283, lng: -98.5795 },
    maxZoom: 14,
  });

  window.map = map;

  const locations = await getLocations();

  if (map) {
    map.addListener('click', () => {
      window.dataLayer.push({ event: 'location_map_interactions', map_interaction_type: 'click' });
      console.log('location_map_interactions');
    });
  }

  each(locations.features, (location) => {
    const lat = Number(location.geometry.coordinates[0]);
    const lng = Number(location.geometry.coordinates[1]);

    const validLat = lat <= 180 && lat >= -180;
    const validLng = lng <= 180 && lng >= -180;

    if (!validLat || !validLng) {
      return;
    }

    const marker = new window.google.maps.Marker({
      map,
      position: { lat, lng },
      title: location.properties.name,
      id: location.properties.id,
    });

    markers[location.properties.store_number] = marker;

    window.google.maps.event.addListener(marker, 'click', () => {
      window.dataLayer.push({ event: 'location_map_interactions', map_interaction_type: 'click' });
      console.log('location_map_interactions');

      infoWindow.setContent(`
        <div class="title"><b>${location.properties.name}</b></div>
        <div class="address">
          ${location.properties.street_1}<br>
          ${location.properties.city},
          ${location.properties.state}
          ${location.properties.zip}<br>
          Store #${location.properties.store_number}
        </div>
        <a class="details_link" data-store="${location.properties.name}" href="${location.properties.url}">Full Details</a>
      `);
      infoWindow.open(map, marker);
    });
  });

  document.addEventListener('shouldFocusMarkerId', (e) => {
    const marker = markers[e.detail];
    const latLng = marker.getPosition();

    window.google.maps.event.trigger(marker, 'click');
    map.panTo(latLng);
    map.setZoom(12);
  });
};

const getOriginFromAddress = (address) => {
  const isZipCode = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(address);

  if (isZipCode) {
    return fetch(`https://store-locator-cache.wndsr.io/latlng_from_zip?zip=${address}`)
      .then((response) => response.json())
      .then((res) => {
        const data = res.data;
        if (data && data.lat && data.lng) {
          return { lat: Number(data.lat), lng: Number(data.lng) };
        }
        return Promise.reject(new Error('Invalid data from zip code lookup'));
      })
      .catch((error) => {
        console.error('err:', error);
        return Promise.reject(error);
      });
  }

  return new Promise((resolve, reject) => {
    geocoder.geocode({ address }, (results, status) => {
      if (
        status === window.google.maps.GeocoderStatus.OK &&
        status !== window.google.maps.GeocoderStatus.ZERO_RESULTS
      ) {
        const location = results[0].geometry.location;
        resolve(location);
      } else {
        console.log('Unable to find address');
        reject(new Error('unable to find address'));
      }
    });
  });
};

export default () => {
  const mapElement = document.querySelector('[data-store-locator-map]'); // Changed variable name

  if (!mapElement) {
    return;
  }

  window.initStoreLocator = initStoreLocator;

  const scr = document.createElement('script');
  scr.type = 'text/javascript';
  scr.src =
    'https://maps.googleapis.com/maps/api/js?v=weekly&key=AIzaSyC7XvXhUPFl-cznGxNKYXcbFbSopaQTzP8&callback=initStoreLocator&libraries=geometry';
  document.body.appendChild(scr);

  document.querySelector('[data-store-locator-form]').addEventListener('submit', async (event) => {
    event.preventDefault();

    const address = document.querySelector('[data-store-locator-address]').value;
    const range = document.querySelector('[data-store-locator-range]').value;

    document.querySelector('[data-store-locator-results]').classList.add('StoreLocator__results--loading');

    try {
      const location = await getOriginFromAddress(address);
      const locationsInRange = await getLocationsInRange(location, range);

      setBoundsToLocations(locationsInRange);

      const event = new CustomEvent('locationsInRangeDidUpdate', {
        detail: { locations: locationsInRange, range },
      });
      document.dispatchEvent(event);
    } catch (error) {
      console.log('err', error);
      const event = new CustomEvent('locationsInRangeDidUpdate', {
        detail: { locations: [], range },
      });
      document.dispatchEvent(event);
    }
  });

  LocationsInRange();

  console.log('init locations in range');
};
